import { api, webapp, lang } from 'config';
import Request from '../utils/request';

export const getDarwinsSearch = (data = {}) => {
    const configRequest = {
        uri: `${api}/products/search`,
        data,
    };
    return Request.get(configRequest).execute()
        .then(response => response.data);
};

export const getLooserUsersPercentage = () => {
    const configRequest = {
        uri: `${api}/accounting/profitsResume/looserUsersPercentage`,
    };
    return Request.get(configRequest).execute()
        .then(response => response.data);
};

export const getMifidCountries = () => {
    const configRequest = {
        uri: `${api}/mifid/countries`,
    };
    return Request.get(configRequest).execute()
        .then(response => response.data);
};

export const getForbiddenCountries = () => {
    const configRequest = {
        uri: `${api}/user/entry-points/bootcamp/forbidden-countries`,
    };
    return Request.get(configRequest).execute()
        .then(response => response.data);
};

export const getRegulatedCompaniesCountries = () => {
    const configRequest = {
        uri: `${api}/user/regulated-companies/countries?availableForRegister=true`,
    };
    return Request.get(configRequest).execute()
        .then(response => response.data);
};

export const getCountryByIp = () => {
    const configRequest = {
        uri: `${webapp}${lang !== 'en' ? `/${lang}` : ''}/country`,
    };
    return Request.get(configRequest).execute()
        .then(response => response.data);
};

export const getAffiliateName = (token = null) => {
    const configRequest = {
        uri: `${api}/affiliates/affiliateuser/username.json`,
        data: {
            token,
        }
    };
    return Request.get(configRequest).execute()
        .then(response => response.data);
};

export const getFilter = (predefinedFilterName) => {
    const configRequest = {
        uri: `${api}/filters/predefinedfilter/products/`,
        data: {
            predefinedFilterName,
            page: 0,
            size: 24,
            period: "default",
            orderField: "",
            order: "DESC",
        }
    };
    return Request.post(configRequest).execute()
        .then(response => response.data);
};

export const getCoupon = (type) => {
    const configRequest = {
        uri: `${api}/payment-subscription/coupons`,
        data: {
            type,
        }
    };
    return Request.post(configRequest).execute()
        .then(response => response.data);
};

